export const gradeList = ['N', 'K1', 'K2', 'K3', 'P1', 'P2', 'na'];
export const excludeMenuList = ['requirement', 'student-requirement', 'online-course', 'notify', 'video', 'setting-requirement', 'enquiry'];